import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  ai: await fetch("./endpoint/ai")
    .then((res) => res.text())
    .then((text) => text.trim())
    .catch(() => ""),

  tomato: await fetch("./endpoint/tomato")
    .then((res) => res.text())
    .then((text) => text.trim())
    .catch(() => ""),
};

//-----------------------------------------------------------------------------------

const endpointSlice = createSlice({
  name: "endpoint",
  initialState,
  reducers: {},
});

//-----------------------------------------------------------------------------------

export const getEndpointAI = (state) => {
  return state.endpoint.ai;
};

export const getEndpointTomato = (state) => {
  return state.endpoint.tomato;
};

//-----------------------------------------------------------------------------------

export default endpointSlice.reducer;
